import './componenteTablaLight.css';
import EmpleadoAsignadoComponenteTablaLight from './EmpleadoAsignadoComponenteTablaLight';
import EstadoComponenteTablaLight from './EstadoComponenteTablaLight';
import { Link } from 'react-router-dom';
export default function ComponenteTablaLight({ stro, estados }) {
  function formatDate(dateString) {
    const [year, month, day] = dateString.split('-');
    return `${day}-${month}-${year}`;
  }
  const optionsPrioridad = [
    { label: '', value: 0 },
    { label: 'BAJA', value: 1 },
    { label: 'MEDIA', value: 2 },
    { label: 'ALTA', value: 3 },
  ];
  const prioridadSeleccionado = optionsPrioridad.find(p => p.value === Number(stro.prioridad));
  return (
    <tr className='bodyTablaDark bodyTablaLight'>
      <th className='textoBodyTablaLight'>{stro?.nroStro?.toString().substring(3)}</th>
      <th className='textoBodyTablaLight'>{stro?.entryId}</th>
      <th className='textoBodyTablaLight'>{stro?.pza}</th>
      <th className='textoBodyTablaLight'>{stro?.dom}</th>
      <th className='textoBodyTablaLight'>{formatDate(stro?.fechaDenuncia)}</th>
      <th className='textoBodyTablaLight'>{formatDate(stro?.fechaStro)}</th>
      <th className='textoBodyTablaLight'>{stro?.recepcionRecChoques ? formatDate(stro?.recepcionRecChoques) : null}</th>
      <th className='textoBodyTablaLight'>{stro?.fechaVencimiento ? formatDate(stro?.fechaVencimiento) : null}</th>
      <th className='textoBodyTablaLight'>{prioridadSeleccionado.label}</th>
      <EmpleadoAsignadoComponenteTablaLight stro={stro} />
      <EstadoComponenteTablaLight stro={stro} estados={estados} />
      <th className='textoBodyTablaLight'>{stro?.catStro ? stro.catStro : stro.tipoStro}</th>
      <th className='col-icon'>
        <Link to={`/${stro?.id}`} className='ingresarContainerBodyLight'>
          <i className='bi bi-arrow-right' style={{ color: '#FFFFFF' }}></i>
        </Link>
      </th>
    </tr>
  );
}
